import { faEye } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import {
  Button,
  Form,
  InputGroup,
  Modal,
  Table,
  Tab,
  Tabs,
} from "react-bootstrap";
import "./Hotel.css";
import { IndexUse } from "./IndexUse";
import CustomPaginate from "../../../../../../common/custompaginate/CustomPaginate";

const Hotel = () => {
  const { country, name, setName, fetch } = IndexUse();

  const [selectedHotel, setSelectedHotel] = useState(null);
  const [showDetailsModal, setShowDetailsModal] = useState(false);

  const handlePageChange = async (page) => {
    await fetch(page);
  };

  const handleShowDetails = (hotel) => {
    setSelectedHotel(hotel);
    setShowDetailsModal(true);
  };

  const handleCloseModal = () => {
    setShowDetailsModal(false);
    setSelectedHotel(null);
  };

  return (
    <>
      <section className="Collage_intern application_section">
        <div className="serach_header">
          <InputGroup className="search_box">
            <Form.Control
              placeholder="Search Hotel Name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="search_input"
            />
            <div className="search_btn">
              <i className="fa fa-search"></i>
            </div>
          </InputGroup>
        </div>

        <div className="Dashboard__ActiveApplications card_box">
          <h5 className="mb-3 card_heading_holder">Hotels List</h5>

          <div className="custom_table table_scroll">
            <Table borderless responsive hover>
              <thead className="table-light">
                <tr>
                  <th>Sr. No.</th>
                  <th>Hotel Name</th>
                  <th>Email</th>
                  <th>Contact Number</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {country?.data?.length > 0 ? (
                  country.data.map((val, index) => (
                    <tr key={val.id}>
                      <td>
                        {(country.current_page - 1) * country.per_page +
                          index +
                          1}
                      </td>
                      <td>
                        <strong>
                          {val.name} {val.last_name || ""}
                        </strong>
                      </td>
                      <td>{val.email}</td>
                      <td>{val.contact_no}</td>
                      <td>
                        <Button
                          variant="outline-primary"
                          size="sm"
                          onClick={() => handleShowDetails(val)}
                          title="View Hotel Details"
                        >
                          <FontAwesomeIcon icon={faEye} /> View Details
                        </Button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan="5"
                      className="text-center py-4 fw-bold text-muted"
                    >
                      No Hotels Found
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>

            <CustomPaginate
              currentPage={country?.current_page || 1}
              totalPages={country?.total_pages || 1}
              handlePageChange={handlePageChange}
            />
          </div>
        </div>
      </section>

      {/* ====================== HOTEL DETAILS MODAL ====================== */}
      <Modal
        show={showDetailsModal}
        onHide={handleCloseModal}
        size="xl"
        centered
        scrollable
      >
        <Modal.Header closeButton className="bg-success text-white">
          <Modal.Title>
            <FontAwesomeIcon icon={faEye} className="me-2" />
            Hotel Details - {selectedHotel?.name}{" "}
            {selectedHotel?.last_name || ""}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedHotel && (
            <Tabs defaultActiveKey="basic" className="mb-4" fill>
              {/* Basic Info */}
              <Tab eventKey="basic" title="Basic Information">
                <Table bordered hover responsive>
                  <tbody>
                    <tr>
                      <th>Hotel Name</th>
                      <td>
                        {selectedHotel.name} {selectedHotel.last_name || ""}
                      </td>
                    </tr>
                    <tr>
                      <th>Email</th>
                      <td>{selectedHotel.email}</td>
                    </tr>
                    <tr>
                      <th>Contact Number</th>
                      <td>{selectedHotel.contact_no}</td>
                    </tr>
                    <tr>
                      <th>Referral Code</th>
                      <td>{selectedHotel.referal_code || "N/A"}</td>
                    </tr>
                    <tr>
                      <th>Status</th>
                      <td>
                        <span
                          className={`badge ${
                            selectedHotel.status ? "bg-success" : "bg-danger"
                          }`}
                        >
                          {selectedHotel.status ? "Active" : "Inactive"}
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <th>Registered On</th>
                      <td>
                        {new Date(selectedHotel.createdAt).toLocaleDateString(
                          "en-IN",
                        )}
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </Tab>

              {/* Establishment Details */}
              <Tab eventKey="establishment" title="Establishment Details">
                <Table bordered hover>
                  <tbody>
                    <tr>
                      <th>Establishment Name</th>
                      <td>
                        {selectedHotel.Hotel_Detail?.establishment_name ||
                          "N/A"}
                      </td>
                    </tr>
                    <tr>
                      <th>Website</th>
                      <td>
                        {selectedHotel.Hotel_Detail?.establishment_web_url ||
                          "N/A"}
                      </td>
                    </tr>
                    <tr>
                      <th>Address</th>
                      <td>
                        {selectedHotel.Hotel_Detail?.establishment_address ||
                          "N/A"}
                      </td>
                    </tr>
                    <tr>
                      <th>Current Address</th>
                      <td>
                        {selectedHotel.Hotel_Detail
                          ?.establishment_current_address || "N/A"}
                      </td>
                    </tr>
                    <tr>
                      <th>Street</th>
                      <td>
                        {selectedHotel.Hotel_Detail?.accomodation_street ||
                          "N/A"}
                      </td>
                    </tr>
                    <tr>
                      <th>Postal Code</th>
                      <td>
                        {selectedHotel.Hotel_Detail?.accomodation_postal_code ||
                          "N/A"}
                      </td>
                    </tr>
                    <tr>
                      <th>City</th>
                      <td>
                        {selectedHotel.Hotel_Detail?.accomodation_city || "N/A"}
                      </td>
                    </tr>
                    <tr>
                      <th>Country</th>
                      <td>
                        {selectedHotel.Hotel_Detail?.accomodation_country ||
                          "N/A"}
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </Tab>

              {/* Electronic Signature */}
              <Tab eventKey="signature" title="Electronic Signature">
                <Table bordered hover>
                  <tbody>
                    <tr>
                      <th>First Name</th>
                      <td>
                        {selectedHotel.HotelElectronicSignature?.first_name ||
                          "N/A"}
                      </td>
                    </tr>
                    <tr>
                      <th>Last Name</th>
                      <td>
                        {selectedHotel.HotelElectronicSignature?.last_name ||
                          "N/A"}
                      </td>
                    </tr>
                    <tr>
                      <th>Job Title</th>
                      <td>
                        {selectedHotel.HotelElectronicSignature?.job_title ||
                          "N/A"}
                      </td>
                    </tr>
                    <tr>
                      <th>Professional Email</th>
                      <td>
                        {selectedHotel.HotelElectronicSignature?.prof_email ||
                          "N/A"}
                      </td>
                    </tr>
                    <tr>
                      <th>Professional Contact</th>
                      <td>
                        {selectedHotel.HotelElectronicSignature
                          ?.prof_contact_no || "N/A"}
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </Tab>

              {/* Internship Supervisor */}
              <Tab eventKey="supervisor" title="Internship Supervisor">
                <Table bordered hover>
                  <tbody>
                    <tr>
                      <th>First Name</th>
                      <td>
                        {selectedHotel.HotelInternshipSupervisor?.first_name ||
                          "N/A"}
                      </td>
                    </tr>
                    <tr>
                      <th>Last Name</th>
                      <td>
                        {selectedHotel.HotelInternshipSupervisor?.last_name ||
                          "N/A"}
                      </td>
                    </tr>
                    <tr>
                      <th>Job Title</th>
                      <td>
                        {selectedHotel.HotelInternshipSupervisor?.job_title ||
                          "N/A"}
                      </td>
                    </tr>
                    <tr>
                      <th>Email</th>
                      <td>
                        {selectedHotel.HotelInternshipSupervisor?.prof_email ||
                          "N/A"}
                      </td>
                    </tr>
                    <tr>
                      <th>Contact No</th>
                      <td>
                        {selectedHotel.HotelInternshipSupervisor
                          ?.prof_contact_no || "N/A"}
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </Tab>

              {/* Sirene Identification */}
              <Tab eventKey="sirene" title="Sirene Identification">
                <Table bordered hover>
                  <tbody>
                    <tr>
                      <th>SIRET</th>
                      <td>
                        {selectedHotel.HotelSireneIdentification?.siret ||
                          "N/A"}
                      </td>
                    </tr>
                    <tr>
                      <th>SIREN</th>
                      <td>
                        {selectedHotel.HotelSireneIdentification?.siren ||
                          "N/A"}
                      </td>
                    </tr>
                    <tr>
                      <th>Trade Name</th>
                      <td>
                        {selectedHotel.HotelSireneIdentification?.trade_name ||
                          "N/A"}
                      </td>
                    </tr>
                    <tr>
                      <th>Activity Code</th>
                      <td>
                        {selectedHotel.HotelSireneIdentification
                          ?.activity_code || "N/A"}
                      </td>
                    </tr>
                    <tr>
                      <th>Legal Form</th>
                      <td>
                        {selectedHotel.HotelSireneIdentification?.legal_form ||
                          "N/A"}
                      </td>
                    </tr>
                    <tr>
                      <th>Number of Employees</th>
                      <td>
                        {selectedHotel.HotelSireneIdentification
                          ?.number_of_employee || "N/A"}
                      </td>
                    </tr>
                    <tr>
                      <th>Internship Capacity</th>
                      <td>
                        {selectedHotel.HotelSireneIdentification
                          ?.internship_capacity || "N/A"}
                      </td>
                    </tr>
                    <tr>
                      <th>Registered Address</th>
                      <td>
                        {selectedHotel.HotelSireneIdentification
                          ?.registered_address || "N/A"}
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </Tab>
            </Tabs>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Hotel;
